import React, {useState, useEffect} from 'react'
import BookVendorAppointment from './BookVendorAppointment'
import {VendorServiceTypeMassage} from '../../Services/ServicesConstants'
import Routes from '../../../constants/RouteConstants'
import {FormComponentPropTypes} from '../onboardingTypes'

function BookMassage(props) {
  return <BookVendorAppointment {...props} serviceType={VendorServiceTypeMassage} viewSingleRoute={Routes.MASSAGE_VIEW_SINGLE} />
}

export default BookMassage

BookMassage.propTypes = FormComponentPropTypes
